import { getPromotionGroupKey } from './promotionGroup';

export type EvoRoomCardItem = {
  room: RoomType;
  promotionKey: string; // '' when the rate has no promotions
  configurations: MealPlanType[]; // group configurations, sorted by finalPrice ascending
};

// Expands rooms into one card item per (room × promotionKey) group within the selected board
// class, so rates that differ only by a benefit are rendered as separate cards (MPH-652).
// Items are globally sorted by their cheapest price (room name as tie-break).
export function getEvoRoomCardItems(
  rooms: readonly RoomType[] | undefined,
  selectedBoardClass: BoardClassType | undefined
): EvoRoomCardItem[] {
  if (!rooms || !selectedBoardClass) return [];

  const items: EvoRoomCardItem[] = [];
  rooms.forEach((room) => {
    const groups = new Map<string, MealPlanType[]>();
    room.configurations
      .filter((config) => config.boardClass === selectedBoardClass)
      .forEach((config) => {
        const key = getPromotionGroupKey(config);
        const group = groups.get(key);
        if (group) {
          group.push(config);
        } else {
          groups.set(key, [config]);
        }
      });
    groups.forEach((configurations, promotionKey) => {
      items.push({
        room,
        promotionKey,
        configurations: [...configurations].sort((a, b) => a.finalPrice - b.finalPrice),
      });
    });
  });

  return items.sort(
    (a, b) => a.configurations[0].finalPrice - b.configurations[0].finalPrice || a.room.name.localeCompare(b.room.name)
  );
}
